/* import __COLOCATED_TEMPLATE__ from './market-input-text-formatted.hbs.js'; */
var _dec, _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@ember/component';
import { action, computed, set } from '@ember/object';
import { inject as service } from '@ember/service';
/**
 * MarketInputTextFormatted combines the functionality of sq-input-formatted into a
 * Market UI market-input-text element.
 * @param {any} value Value of the input
 * @param {string} [inputClassNames] Optional classes to apply to the input
 * @param {string} [placeholder] Optional placeholder text
 * @param {string} [tooltip] Optional clickable tooltip
 * @param {string} [type=text] Type of input
 * @param {string} [size] Optional for setting input size. Sizes small and medium visually hide the label, i.e. "large", "medium", "small"
 * @param {string} [inputmode] Optional hint to what type of input is expected
 * @param {boolean} [disabled=false]
 * @param {boolean} [autofocus=false]
 * @param {boolean} [autocomplete=true]
 * @param {boolean} [hideCurrencySymbol=false] Option to hide the currency symbol for rendered currency values
 * @param {function} [valueToStore]
 * @param {function} [valueToShow]
 * @param {function} [onChange]
 * @param {action} [didInsert] Optional function that will fire after the component is inserted and this.input is set
 * @param {action} [onFocus]
 * @param {action} [handleChange]
 * @param {function} [handleDidEndEditing]
 */
let MarketInputTextFormatted = (_dec = computed('value'), (_class = class MarketInputTextFormatted extends Component {
  constructor(...args) {
    super(...args);
    // Passed in
    _defineProperty(this, "value", void 0);
    _defineProperty(this, "inputClassNames", void 0);
    _defineProperty(this, "tooltip", void 0);
    _defineProperty(this, "accessoryText", void 0);
    _defineProperty(this, "disabled", false);
    _defineProperty(this, "autofocus", false);
    _defineProperty(this, "autocomplete", true);
    _defineProperty(this, "type", 'text');
    _defineProperty(this, "size", void 0);
    _defineProperty(this, "hideCurrencySymbol", false);
    // Default service, if an optional is not passed in from the external wrapper component
    _initializerDefineProperty(this, "formatter", _descriptor, this);
    // Internal
    _defineProperty(this, "input", void 0);
  }
  onChange() {}
  onFocus() {}
  onBlur() {}
  get labelId() {
    return `market-input-label-${this.elementId}`;
  }
  get placeholder() {
    return null;
  }

  // These functions can be overridden by child components.
  // Value to return to onChange
  valueToStore(value) {
    return value;
  }

  // Value to display in the input
  valueToShow(value) {
    return value;
  }

  // Fires when component has been inserted into the DOM
  didInsert() {}

  // Fires on focus
  onFocusAction() {
    this.onFocus();
  }

  // Fires on blur
  onBlurAction() {
    this.onBlur();
  }

  // Fires after each input
  handleChange(value) {
    this.onChange(value);
  }

  // Fires on blur
  handleDidEndEditing() {
    const newValue = this.formatter?.format?.(this.input.value);
    set(this, 'value', newValue);
    this.onChange(this.valueToStore(newValue));
  }
  willDestroy(...args) {
    super.willDestroy(...args);
    this.input?.removeEventListener('change', this.handleDidEndEditing);
  }
  get displayValue() {
    return this.valueToShow(this.value);
  }
  async registerChangeHandler() {
    this.marketInput = this.element.querySelector('market-input-text');
    this.input = await this.marketInput.getInputElement();
    this.input.addEventListener('change', this.handleDidEndEditing);
    this.didInsert();
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onFocusAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onFocusAction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onBlurAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onBlurAction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleDidEndEditing", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDidEndEditing"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayValue", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "displayValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "registerChangeHandler", [action], Object.getOwnPropertyDescriptor(_class.prototype, "registerChangeHandler"), _class.prototype)), _class));
export { MarketInputTextFormatted as default };